import { crypto } from '../environment/crypto/index.js';

const hashObject = async data => {
  const str = JSON.stringify(data);
  const hashBuffer = await crypto.digest256(str);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(bin => bin.toString(16).padStart(2, '0')).join('');
  return hashHex;
};

export { hashObject };
